import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { 
    InfMunCarregaInterface, infPercurso, ProdutoPredominanteInterface, 
    AutorizacaoDownloadInterface, EstadoInterface, MunicipioInterface,  
    LacresManifestoInterface,
    infMunDescargaInterface,
    
    infNFesInterface,
    infCTesInterface,
    ModalRodoviarioInterface,
    ManifestoState,
    Condutor,
    LacreInterface,
    ReboqueInterface,
    CiotInterface,
    ContratanteInterface,
    DispInterface,
    infPagInterface,
    SeguroInterface,
    ModalAereoInterface,
    ModalFerroviarioInterface,
    VagaoInterface,
    ModalAquaticoInterface,
    InfTermCarregInterface,
    infTermDescarregInterface,
    infEmbCombInterface,
    infUnidCargaVaziaInteface,
    infUnidTranspVaziaInterface,
    InfMDFesInterface
} from "../interfaces";

const initialModalAquatico: ModalAquaticoInterface = {
    id: 0,
    irin: '',
    tpemb: '01',
    cembar: '',
    xembar: '',
    nviag: '',
    cprtemb: '',
    cprtdest: '',
    prttrans: '',
    tpnav: 9,//nao informado
    infTermCarreg: [],
    infTermDescarreg: [],
    infEmbComb: [],
    infUnidCargaVazia: [],
    infUnidTranspVazia: [],
}

const initialModalAereo: ModalAereoInterface = {
    nac: '',
    matr: '',
    nvoo: '',
    caeremb: '',
    caerdes: '',
    dvoo: ''
}

const initialModalFerroviario: ModalFerroviarioInterface = {
    trem: {
        dhtrem: '',
        qvag: 1,
        xdest: '',
        xori: '',
        xpref: ''
    },
    vag: []
}


export const initialModalRodoviario: ModalRodoviarioInterface =  {
    tracao: {
        condutores: [],
        prop: {},
        capKG: '',
        capM3: '',
        placa: '',
        tpCar: '0',
        tara: '',
        cint: '',
        renavam: '',
        tpRod: '1',
        uf: 'RN'
    },
    reboques: [],
    infANTT: {
        rntrc : '',
        infPag: [],
        infCIOT: [],
        infContratante: [],
        valePed: {
            categCombVeic: '',
            disp: []
        }
    },
    lacres: []
}


const initialState: ManifestoState = {
    manifesto: {
        nmdf: "1",
        tpemit: 2,
        tptransp: 0,
        modal: 1,
        chave: '',
        serie: '1',
        mod: '58',
        ufini: "RN",
        uffim: "RN",
        vcarga: 0,
        qcarga: 0,
        cunid: "01",
        dhcancel: '',
        dhemi: '',
        dhencer: '',
        protocolo: '',
        situacao: 1,
        infMunCarrega: [],
        infPercurso: [],
        infMunDescarga: [],
        prodPred: {},
        authDownload: [],
        infcpl: "",
        infadfisco: "",
        lacres: [],
        modal_rodoviario: initialModalRodoviario,
        modal_aereo: initialModalAereo,
        modal_ferroviario: initialModalFerroviario,
        modal_aquatico: initialModalAquatico,
        seg: []
    },
    listaErrors: {
        uffim: [],
        ufini: [],
        nmdf: [],
        tpemit: [],
        tptransp: [],
        modal: [],
        infMunCarrega: [],
        infPercurso: [],
        prodPred_cean: [],
        prodPred_ncm: [],
        prodPred_tpcarga: [],
        prodPred_xprod: [],
        modal_rodoviario_tracao_placa: [],
        modal_rodoviario_tracao_tara: [],
        modal_rodoviario_tracao_uf: [],
        modal_rodoviario_tracao_renavam: [],
        modal_rodoviario_tracao_tpcar: [],
        modal_rodoviario_tracao_tpRod: [],

    },

    selectEstados: [{
        id: 0,
        uf: "",
        name: "Selecione uma UF",
        cod_ibge: 0,
        pais: { name: 'Brasil' }
    }],
    selectMunicipios: [
        {
            id: 0,
            name: 'Selecione uma UF Inicial',
            estado: {
                uf: 'Selecione'
            },
            capital: 0,
            cod_ibge: 0,
            
        }
    ],
    selectMunicipiosCarregamentos: [
        {
            id: 0,
            name: 'Selecione uma UF Final',
            estado: {
                uf: 'Selecione'
            },
            capital: 0,
            cod_ibge: 0,
            
        }
    ],
    selectMunicipiosDescarregamentos: []
}

const manifestoSlice = createSlice({
    name: "manifesto",
    initialState,
    reducers: {

        changeAnttRntrc: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                         modal_rodoviario: {
                            ...state.manifesto.modal_rodoviario,
                            infANTT: {
                                ...state.manifesto.modal_rodoviario.infANTT,
                                rntrc: action.payload,
                                infCIOT: [],
                                infContratante: [],
                                infPag: [],
                                valePed: {
                                    categCombVeic: '',
                                    disp: []
                                }
                            }
                         }
                    }
            }

        },

        clearError: (state, action) => {
            const {[action.payload]:_, ...novalista} = state.listaErrors
            
            return {
                ...state,
                listaErrors: {...novalista}
            }

        },
   
        loadMunicipiosDescargaSelect: (state) => {
            return {
                ...state,
                selectMunicipiosDescarregamentos: state.manifesto.infMunDescarga.map(item => {
                    return {
                        id: item.municipio_id,
                        name: item.name
                    }
                })

            }
        },
        
        changeTracaoManifesto: (state, action) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: {...state.manifesto.modal_rodoviario.tracao, ...action.payload},
                            }
                        },
                        
                    }
                }
            }
        },

        changeModalFerroviarioTrem: (state, action) => {
            if (state.manifesto.modal_ferroviario) {

                if (state.manifesto.modal_ferroviario?.trem) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_ferroviario: {
                                ...state.manifesto.modal_ferroviario,
                                trem: {...state.manifesto.modal_ferroviario.trem, ...action.payload},
                            }
                        },
                        
                    }
                }
            }
        },

        changeTracaoProp: (state, action) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: {
                                    ...state.manifesto.modal_rodoviario.tracao, 
                                    prop: {...state.manifesto.modal_rodoviario.tracao.prop, ...action.payload}
                                },
                            }
                        },
                        
                    }
                }
            }
        },

        clearTracaoProp: (state) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: {
                                    ...state.manifesto.modal_rodoviario.tracao, 
                                    prop: {}
                                },
                            }
                        },
                        
                    }
                }
            }

        },

        addCondutor: (state, action: PayloadAction<Condutor>) => {
            state.manifesto.modal_rodoviario.tracao.condutores.push(action.payload)
        },

        removeCondutor: (state, action: PayloadAction<number>) => {

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        tracao: {
                            ...state.manifesto.modal_rodoviario.tracao,
                            condutores: state.manifesto.modal_rodoviario.tracao.condutores.filter((item:Condutor) => item.id.toString() !== action.payload.toString())
                        }
                    }
                }
            }

        },

        setManifesto: (state, action) => {
            state.manifesto = {...state.manifesto, ...action.payload}

            if (action.payload['modal']) {
                state.manifesto = {...state.manifesto, modal_rodoviario: {}}
                state.manifesto = {...state.manifesto, modal_aereo: {}}
                state.manifesto = {...state.manifesto, modal_ferroviario: {}}
                state.manifesto = {...state.manifesto, modal_aquatico: {}}

                if (action.payload['modal'] === '1') {
                    state.manifesto = {...state.manifesto, modal_rodoviario: initialModalRodoviario}
                }

                if (action.payload['modal'] === '2') {
                    state.manifesto = {...state.manifesto, modal_aereo: initialModalAereo}
                }

                if (action.payload['modal'] === '4') {
                    state.manifesto = {...state.manifesto, modal_ferroviario: initialModalFerroviario}
                }

                if (action.payload['modal'] === '3') {
                    state.manifesto = {...state.manifesto, modal_aquatico: initialModalAquatico}
                }
            }
            
        },

        clearManifesto: (state) => {
            return initialState;
        },

        loadManifesto: (state, action) => {
            return {
                ...state,
                manifesto: action.payload
            }
        },
        
        gravarErrors: (state, action) => {
            
            return {
                ...state,
                listaErrors: {...action.payload}
            };
        },

        changeProdutoPredominante: (state, action) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    prodPred: {...state.manifesto.prodPred, ...action.payload}
                }
            }
        },

        changeModalAereo: (state, action) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aereo: {...state.manifesto.modal_aereo, ...action.payload}
                }
            }
        },

        addLacreManifesto: (state, action: PayloadAction<LacresManifestoInterface>) => {
            state.manifesto.lacres.push(action.payload);
        },

        removerLacreManifesto: (state, action: PayloadAction<number | string>) => {
            if (state.manifesto.lacres.find(item => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        lacres: state.manifesto.lacres.filter(item => item.id !== action.payload)
                    }
                }
            }
        },

        addLacreRodoviario: (state, action: PayloadAction<LacresManifestoInterface>) => {
            state.manifesto.modal_rodoviario.lacres.push(action.payload);
        },

        removerLacreRodoviario: (state, action: PayloadAction<number>) => {
            if (state.manifesto.modal_rodoviario.lacres.find((item: LacreInterface) => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_rodoviario: {
                            ...state.manifesto.modal_rodoviario,
                            lacres: state.manifesto.modal_rodoviario.lacres.filter((item: LacreInterface) => item.id !== action.payload)
                        }
                    }
                }
            }
        },

        addAuthDownload: (state, action: PayloadAction<AutorizacaoDownloadInterface>) => {
            state.manifesto.authDownload.push(action.payload);
        },

        removeAuthDownload: (state, action: PayloadAction<number | string>) => {
            
            if (state.manifesto.authDownload.find(item => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        authDownload: state.manifesto.authDownload.filter((item: AutorizacaoDownloadInterface) => item.id !== action.payload)
                    }
                }
            }

        },

        addListaMunicipiosCarregamento: (state, action: PayloadAction<InfMunCarregaInterface>) => {
            state.manifesto.infMunCarrega.push(action.payload);
        },
        
        removeMunicipioCarregamento: (state, action: PayloadAction<number>) => {
            
            return {
                ...state,
                listaMunicipiosCarregamento: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.id?.toString() !== action.payload.toString()),
                manifesto: {
                    ...state.manifesto,
                    infMunCarrega: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.id?.toString() !== action.payload.toString())
                }
            }
        },

        addListaUFPercurso: (state, action: PayloadAction<infPercurso>) => {
            state.manifesto.infPercurso.push(action.payload);
        },       

        removeListaUFPercurso: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infPercurso: state.manifesto.infPercurso.filter((estado: infPercurso) => estado.id.toString() !== action.payload.toString())
                }
            }
        },

        setEstados: (state, action: PayloadAction<EstadoInterface[]>) => {
            return {
                ...state,
                selectEstados: [...state.selectEstados, ...action.payload]
            }
        },

        setSelectMunicipios: (state, action: PayloadAction<MunicipioInterface[]>) => {
            state.selectMunicipios = action.payload;
        },

        setSelectMunicipiosCarregamento: (state, action: PayloadAction<MunicipioInterface[]>) => {
            state.selectMunicipiosCarregamentos = action.payload;
        },
      
        setinfMunCarrega: (state, action: PayloadAction<InfMunCarregaInterface>) => {
            state.manifesto.infMunCarrega.push(action.payload);
        },

        removeInfMunCarrega: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                infMunCarrega: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.municipio_id !== action.payload)
            }
        },

        setinfPercurso: (state, action: PayloadAction<infPercurso>) => {
            state.manifesto.infPercurso.push(action.payload);
        },

        removeInfPercurso: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                infPercurso: state.manifesto.infPercurso.filter((estado: infPercurso) => estado.estado_id !== action.payload)
            }
        },

        setProdPred: (state, action: PayloadAction<ProdutoPredominanteInterface>) => {
            state.manifesto.prodPred = action.payload
        },

        removeProdPred: (state) => {
            return {
                ...state,
                prodPred: {}
            }
        },

        addListaMunicipiosDescarregamento: (state, action: PayloadAction<infMunDescargaInterface>) => {
         
            state.manifesto.infMunDescarga.push({
                id: action.payload.id,
                municipio_id: action.payload.municipio_id,
                name: action.payload.name,
                infNFe: [],
                infCTe: [],
                infMDFe: []
            });

            if (!state.selectMunicipiosDescarregamentos.find(item => item.id === action.payload.municipio_id)) {
                
                state.selectMunicipiosDescarregamentos.push({id: action.payload.municipio_id, name: action.payload.name});
            }
            
        },
        
        removeListaMunicipioDescarregamento: (state, action: PayloadAction<number>) => {
            const municipioId = state.manifesto.infMunDescarga.filter((municipio: infMunDescargaInterface) => municipio.id.toString() === action.payload.toString())[0].municipio_id
            
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.id !== action.payload)
                },
                selectMunicipiosDescarregamentos: state.selectMunicipiosDescarregamentos.filter(item => item.id !== municipioId)
            }
        },

        addNFe: (state, action: PayloadAction<infNFesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infNFe?.push(action.payload)
            }
            
        },

        updateNFe: (state, action: PayloadAction<infNFesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infNFe as infNFesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());
                
                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infNFe?.filter((item: infNFesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infNFe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())
    
                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infNFe?.push(action.payload)
                    }
                }
            }
        },

        removeNFe: (state, action: PayloadAction<{municipio_id: number; chNFe: string}>) => {
            
            const munDescarga = state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            

            if (index !== -1) {
               let newLista = state.manifesto.infMunDescarga[index].infNFe?.filter((item: infNFesInterface) => item.chNFe !== action.payload.chNFe) || []

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                            infMunDescarga: [
                                ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id), 
                                { 
                                    id: munDescarga[0].id,
                                    municipio_id: action.payload.municipio_id, 
                                    name: munDescarga[0].name, 
                                    infNFe: newLista,
                                    infCTe: munDescarga[0].infCTe,
                                    infMDFe: munDescarga[0].infMDFe
                                    
                                }
                            ]
                    }
                }
            }
          
        },

        clearNFe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infNFe: []
                },
            }
        },
        
        clearCTe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infCTe: []
                },
            }
        },
        
        addCTe: (state, action: PayloadAction<infCTesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infCTe?.push(action.payload)
            }
            
        },

        removeCTe: (state, action: PayloadAction<{municipio_id: number; chCTe: string}>) => {
            const munDescarga = state.manifesto.infMunDescarga.filter((item) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id === action.payload.municipio_id)
            let newLista

            if (index !== -1) {
               newLista = state.manifesto.infMunDescarga[index].infCTe?.filter((item: infCTesInterface) => item.chCTe !== action.payload.chCTe) || []

                return {
                    ...state,
                        manifesto: {
                            ...state.manifesto,
                                infMunDescarga: [
                                    ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id), 
                                    { 
                                        id: munDescarga[0].id,
                                        municipio_id: action.payload.municipio_id, 
                                        name: munDescarga[0].name, 
                                        infCTe: newLista,
                                        infNFe: munDescarga[0].infNFe,
                                        infMDFe: munDescarga[0].infMDFe
                                    }
                                ]
                        }
                }
            }
           
        },

        updateCTe: (state, action: PayloadAction<infCTesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infCTe as infCTesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());
                
                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infCTe?.filter((item: infCTesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infCTe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())
    
                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infCTe?.push(action.payload)
                    }
                }
            }
        },

        addTracaoReboque: (state, action: PayloadAction<ReboqueInterface>) =>  {
            if (state.manifesto.modal === 1) {
                state.manifesto.modal_rodoviario.reboques.push(action.payload);
            }
        },

        removeTracaoReboque: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        reboques: state.manifesto.modal_rodoviario.reboques.filter((item: ReboqueInterface) => item.placa !== action.payload)
                    }
                }
            }
        },

        addCiot: (state, action: PayloadAction<CiotInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.infCIOT.push(action.payload);
        },

        removeCiot: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT, 
                            infCIOT: state.manifesto.modal_rodoviario.infANTT.infCIOT.filter((item:CiotInterface)=> item.id !== action.payload)
                        }
                    }
                }
            }
        },
        
        addContratante: (state, action: PayloadAction<ContratanteInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.infContratante.push(action.payload);
        },

        removeContratante: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT, 
                            infContratante: state.manifesto.modal_rodoviario.infANTT.infContratante.filter((item:ContratanteInterface)=> item.id !== action.payload)
                        }
                    }
                }
            }
        },

        addDispositivoValePedagio: (state, action: PayloadAction<DispInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.valePed?.disp.push(action.payload);
        },

        removeDispositivoValePedagio: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT, 
                            valePed: {
                                ...state.manifesto.modal_rodoviario.infANTT.valePed,
                                disp: state.manifesto.modal_rodoviario.infANTT.valePed.disp.filter((item:DispInterface)=> item.id !== action.payload)
                            }
                        }
                    }
                }
            }
        },

        changeValePedCategoria: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT, 
                            valePed: {
                                ...state.manifesto.modal_rodoviario.infANTT.valePed,
                                categCombVeic: action.payload
                            }
                        }
                    }
                }
            }
        },

        addInfPag: (state, action: PayloadAction<infPagInterface>) => {
            const sequencias = state.manifesto.modal_rodoviario.infANTT?.infPag.map((item : infPagInterface) => item.id) || []
            const maxSeq = Math.max(sequencias) + 1;
            
            state.manifesto.modal_rodoviario.infANTT?.infPag.push({
                id: maxSeq,
                xNome: action.payload.xNome,
                cpfcnpj: action.payload.cpfcnpj,
                idestrangeiro: action.payload.idestrangeiro,
                vContrato: action.payload.vContrato,
                indAltoDesemp: action.payload.indAltoDesemp,
                indPag: action.payload.indPag,
                vAdiant: action.payload.vAdiant,
                indAntecipaAdiant: action.payload.indAntecipaAdiant,
                tpAntecip: action.payload.tpAntecip,
                codBanco: action.payload.codBanco,
                codAgencia: action.payload.codAgencia,
                CNPJIPEF: action.payload.CNPJIPEF,
                PIX: action.payload.PIX,
                comp: action.payload.comp,
                infPrazo: action.payload.infPrazo,
                
            });
        },

        removeInfPag: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT, 
                            infPag: state.manifesto.modal_rodoviario.infANTT.infPag.filter((item:infPagInterface)=> item.id !== action.payload)
                        }
                    }
                }
            }
        },

        addSeguro: (state, action: PayloadAction<SeguroInterface>) => {
            state.manifesto.seg.push(action.payload);
        },

        removeSeguro: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.filter((item: SeguroInterface) => item.id !== action.payload)
                }
            }
        },

        addVagao: (state, action: PayloadAction<VagaoInterface>) => {
            state.manifesto.modal_ferroviario.vag.push(action.payload)
        },

        removeVagao: (state, action: PayloadAction<number>) => {

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_ferroviario: {
                        ...state.manifesto.modal_ferroviario,
                        vag: state.manifesto.modal_ferroviario.vag.filter((item: VagaoInterface) => 
                            item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        changeModalAquatico: (state, action) => {
            if (state.manifesto.modal_aquatico) {

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico, ...action.payload
                        }
                    },
                    
                }
            }
            
        },

        addTerminalCarrega: (state, action: PayloadAction<InfTermCarregInterface>) => {
            state.manifesto.modal_aquatico.infTermCarreg.push(action.payload);
        },

        removeTerminalCarrega: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico,
                            infTermCarreg: state.manifesto.modal_aquatico.infTermCarreg.filter(
                                (item: InfTermCarregInterface) => item.id.toString() !== action.payload.toString()
                            )
                        }
                    }
            }
        },
        addTerminalDescarrega: (state, action: PayloadAction<infTermDescarregInterface>) => {
            state.manifesto.modal_aquatico.infTermDescarreg.push(action.payload);
        },

        removeTerminalDescarrega: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico,
                            infTermDescarreg: state.manifesto.modal_aquatico.infTermDescarreg.filter(
                                (item: infTermDescarregInterface) => item.id.toString() !== action.payload.toString()
                            )
                        }
                    }
            }
        },

        addComboio: (state, action: PayloadAction<infEmbCombInterface>) => {
            state.manifesto.modal_aquatico.infEmbComb.push(action.payload);
        },

        removeComboio: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico,
                            infEmbComb: state.manifesto.modal_aquatico.infEmbComb.filter(
                                (item: infEmbCombInterface) => item.id.toString() !== action.payload.toString()
                            )
                        }
                    }
            }
        },

        addUnidadeCargaVazia: (state, action: PayloadAction<infUnidCargaVaziaInteface>) => {
            state.manifesto.modal_aquatico.infUnidCargaVazia.push(action.payload);
        },

        removeUnidadeCargaVazia: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico,
                            infUnidCargaVazia: state.manifesto.modal_aquatico.infUnidCargaVazia.filter(
                                (item: infUnidCargaVaziaInteface) => item.id.toString() !== action.payload.toString()
                            )
                        }
                    }
            }
        },
        addUnidadeTransporteVazia: (state, action: PayloadAction<infUnidTranspVaziaInterface>) => {
            state.manifesto.modal_aquatico.infUnidTranspVazia.push(action.payload);
        },

        removeUnidadeTransporteVazia: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico,
                            infUnidTranspVazia: state.manifesto.modal_aquatico.infUnidTranspVazia.filter(
                                (item: infUnidTranspVaziaInterface) => item.id.toString() !== action.payload.toString()
                            )
                        }
                    }
            }
        },

        addMDFe: (state, action: PayloadAction<InfMDFesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infMDFe?.push(action.payload)
            }
            
        },

        updateMDFe: (state, action: PayloadAction<InfMDFesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infMDFe as InfMDFesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());
                
                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infMDFe?.filter((item: InfMDFesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infMDFe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())
    
                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infMDFe?.push(action.payload)
                    }
                }
            }
        },

        removeMDFe: (state, action: PayloadAction<{municipio_id: number; chMDFe: string}>) => {
            
            const munDescarga = state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            

            if (index !== -1) {
               let newLista = state.manifesto.infMunDescarga[index].infMDFe?.filter((item: InfMDFesInterface) => item.chMDFe !== action.payload.chMDFe) || []

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                            infMunDescarga: [
                                ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id), 
                                { 
                                    id: munDescarga[0].id,
                                    municipio_id: action.payload.municipio_id, 
                                    name: munDescarga[0].name, 
                                    infNFe: munDescarga[0].infNFe,
                                    infCTe: munDescarga[0].infCTe,
                                    infMDFe: newLista,
                                }
                            ]
                    }
                }
            }
          
        },

        clearMDFe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMDFe: [],
                    
                },
            }
        },

    }
});

export const { setEstados, setManifesto, setinfMunCarrega, removeInfMunCarrega, setinfPercurso, removeInfPercurso, 
    setProdPred, removeProdPred, addAuthDownload, removeAuthDownload, setSelectMunicipios, addVagao, removeVagao,
    addListaMunicipiosCarregamento, removeMunicipioCarregamento, addListaUFPercurso, removeListaUFPercurso, 
    gravarErrors, clearManifesto, changeProdutoPredominante, loadManifesto, addLacreManifesto, removerLacreManifesto, 
    setSelectMunicipiosCarregamento, addListaMunicipiosDescarregamento, removeListaMunicipioDescarregamento,
    addNFe, removeNFe, clearNFe, addCTe, removeCTe, clearCTe, changeTracaoManifesto, clearError, changeTracaoProp, 
    clearTracaoProp, addCondutor, removeCondutor, addLacreRodoviario, removerLacreRodoviario, 
    loadMunicipiosDescargaSelect, addTracaoReboque, removeTracaoReboque, changeAnttRntrc, addCiot, removeCiot, 
    addContratante, removeContratante, addDispositivoValePedagio, removeDispositivoValePedagio, changeValePedCategoria,
    addInfPag, removeInfPag, addSeguro, removeSeguro, updateNFe, changeModalAereo, changeModalFerroviarioTrem, 
    changeModalAquatico, addTerminalCarrega, removeTerminalCarrega, addTerminalDescarrega, removeTerminalDescarrega,
    addComboio, removeComboio,addUnidadeCargaVazia,removeUnidadeCargaVazia, addUnidadeTransporteVazia, 
    removeUnidadeTransporteVazia, updateCTe, addMDFe, removeMDFe, clearMDFe, updateMDFe,
} = manifestoSlice.actions;

export default manifestoSlice.reducer;